<template>
  <!-- replaces the sidebar below the breakpoint -->
  <div class="reg-progress" data-testid="reg-progress">
    <div class="reg-progress__head">
      <span class="reg-progress__label">{{ label }}</span>
      <a class="reg-progress__support" :href="`tel:${SUPPORT_PHONE_HREF}`">{{ SUPPORT_PHONE }}</a>
    </div>
    <div class="reg-progress__track">
      <div class="reg-progress__fill" :style="{ width: `${percent}%` }"></div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { SUPPORT_PHONE, SUPPORT_PHONE_HREF } from '@/components/registration/subcomponents/support';

interface Props {
  label: string;
  percent: number;
}

defineProps<Props>();
</script>

<style scoped lang="scss">
@use '@/assets/registration' as reg;

.reg-progress {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px 16px;
  background: reg.$sidebar-bg;

  &__head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
  }

  &__label {
    font-size: 13px;
    line-height: 20px;
    font-weight: 500;
    color: #fff;
  }

  &__support {
    font-size: 13px;
    line-height: 20px;
    color: reg.$sidebar-link;
  }

  &__track {
    height: 4px;
    border-radius: 9999px;
    background: reg.$sidebar-border;
    overflow: hidden;
  }

  &__fill {
    height: 100%;
    border-radius: 9999px;
    background: var(--tw-color-primary);
    transition: width 0.3s ease;
  }
}
</style>
